import React from 'react';
import { TableOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { filterDeliveryDonwloadN, resetDeliveryN } from '../../actions/deliveryNotes';
import { Tooltip } from 'antd';

export const BtnTable = ({ props, data, isReduced, setIsReduced }) => {

    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(resetDeliveryN());
        const newState = !isReduced;
        setIsReduced(newState);
        dispatch(filterDeliveryDonwloadN({...data, reducedversion: newState}));
    }

    return (
        <button className="btn btn-color btn-danger btn-margin-left" props={props} onClick={handleClick}>
            <TableOutlined/>
            <Tooltip placement="topLeft" title="Opción mostrar tabla" >
                <span className="table-cell-trucate">  {isReduced ? 'Completa' : 'Reducida'} </span>
            </Tooltip>
        </button>
    )
}